import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-cm-datepicker',
  templateUrl: 'datepicker.component.html',
  styleUrls: ['datepicker.component.scss']
})
export class DatepickerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
